var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "SectionContainerPage",
    [
      _c(
        "v-layout",
        { attrs: { column: "" } },
        [
          _c(
            "v-flex",
            [
              _c("SectionAssetDetail", {
                attrs: {
                  title: _vm.titleComputed,
                  breadCrumbs: _vm.breadCrumbs,
                  toolbarActions: [
                    {
                      text: "Edit Equipment",
                      icon: "edit",
                      iconColor: "warning",
                      emitEvent: "onEditEquipmentClicked",
                    },
                  ],
                  assetDetail: _vm.assetDetail,
                  modelList: _vm.modelList,
                  manufacturerList: _vm.manufacturerList,
                  categoryList: _vm.categoryList,
                  activityTypeList: _vm.activityTypeList,
                  assetStatusList: _vm.assetStatusList,
                  locationList: _vm.locationList,
                  clientList: _vm.clientList,
                  userList: _vm.userList,
                  propertyKeyList: _vm.propertyKeyList,
                  isLoading: _vm.isLoading,
                },
                on: {
                  onClickBreadcrumb: (val) =>
                    _vm.$emit("onClickBreadcrumb", val),
                  onEditEquipmentClicked: function ($event) {
                    _vm.showDialogFormAssetEdit = true
                  },
                  onClickViewActivity: (val) =>
                    _vm.$emit("onClickViewActivity", val),
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            [
              _c(
                "v-tabs",
                {
                  attrs: { dark: "" },
                  model: {
                    value: _vm.currentTab,
                    callback: function ($$v) {
                      _vm.currentTab = $$v
                    },
                    expression: "currentTab",
                  },
                },
                [
                  _c(
                    "v-tab",
                    [
                      _c("v-icon", { staticClass: "mr-1" }, [_vm._v("event")]),
                      _vm._v(
                        _vm._s(
                          `Activities (${
                            (_vm.assetDetail.activityList &&
                              _vm.assetDetail.activityList.length) ||
                            0
                          })`
                        ) + "\n        "
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-tab",
                    [
                      _c("v-icon", { staticClass: "mr-1" }, [
                        _vm._v("attachment"),
                      ]),
                      _vm._v(
                        _vm._s(
                          `Attachments (${
                            (_vm.assetDetail.attachmentList &&
                              _vm.assetDetail.attachmentList.length) ||
                            0
                          })`
                        ) + "\n        "
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-tab",
                    [
                      _c("v-icon", { staticClass: "mr-1" }, [
                        _vm._v("list_alt"),
                      ]),
                      _vm._v(
                        _vm._s(
                          `Properties (${
                            (_vm.assetDetail.propertyList &&
                              _vm.assetDetail.propertyList.length) ||
                            0
                          })`
                        ) + "\n        "
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.currentTab === _vm.tabActivities
            ? _c(
                "v-flex",
                [
                  _c("SectionActivityList", {
                    attrs: {
                      xs12: "",
                      isPrimary: false,
                      toolbarActions: [
                        {
                          text: "Activity",
                          icon: "add",
                          iconColor: "success",
                          emitEvent: "onAddNewActivityClicked",
                        },
                      ],
                      activityList: _vm.assetDetail.activityList || [],
                      activityTypeList: _vm.activityTypeList,
                      locationList: _vm.locationList,
                      userList: _vm.userList,
                      modelList: _vm.modelList,
                      assetStatusList: _vm.assetStatusList,
                      title: "Activities",
                      isLoading: _vm.isLoading,
                    },
                    on: {
                      onAddNewActivityClicked: function ($event) {
                        _vm.showDialogFormActivityAdd = true
                      },
                      onClickViewActivity: (val) =>
                        _vm.$emit("onClickViewActivityFromAssetDetail", {
                          ...val,
                          breadCrumbTitle: _vm.titleComputed,
                        }),
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.currentTab === _vm.tabAttachments
            ? _c(
                "v-flex",
                [
                  _c("SectionAttachmentList", {
                    attrs: {
                      xs12: "",
                      isPrimary: false,
                      assetDetail: _vm.assetDetail,
                      attachmentList: _vm.assetDetail.attachmentList || [],
                      activityTypeList: _vm.activityTypeList,
                      userList: _vm.userList,
                      locationList: _vm.locationList,
                      modelList: _vm.modelList,
                      isLoading: _vm.isLoading,
                    },
                    on: {
                      onClickViewAttachment: (val) =>
                        _vm.$emit("onClickViewAttachmentFromAssetDetail", {
                          ...val,
                          breadCrumbTitle: _vm.titleComputed,
                        }),
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.currentTab === _vm.tabProperties
            ? _c(
                "v-flex",
                [
                  _c("SectionPropertyList", {
                    attrs: {
                      xs12: "",
                      isPrimary: false,
                      toolbarActions: [
                        {
                          text: "Property",
                          icon: "add",
                          iconColor: "success",
                          emitEvent: "onAddNewPropertyClicked",
                        },
                      ],
                      propertyList: _vm.assetDetail.propertyList || [],
                      propertyKeyList: _vm.propertyKeyList,
                      isLoading: _vm.isLoading,
                    },
                    on: {
                      onAddNewPropertyClicked: function ($event) {
                        _vm.showDialogFormAssetPropertyAdd = true
                      },
                      onEditPropertyClicked: (val) => [
                        (_vm.propertyToEdit = val.propertyToEdit),
                        (_vm.showDialogFormAssetPropertyEdit = true),
                      ],
                      onRemovePropertyClicked: (val) =>
                        _vm.onConfirmRemoveProperty(val),
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("DialogFormAssetEdit", {
        attrs: {
          assetDetail: _vm.assetDetail,
          showDialog: _vm.showDialogFormAssetEdit,
          modelList: _vm.modelList,
          manufacturerList: _vm.manufacturerList,
          categoryList: _vm.categoryList,
          locationList: _vm.locationList,
          clientList: _vm.clientList,
          isLoading: _vm.isLoading,
        },
        on: {
          onCancelClicked: function ($event) {
            _vm.showDialogFormAssetEdit = false
          },
          onSubmitClicked: (val) => [
            _vm.onDialogFormAssetEditSubmit(val),
            (_vm.showDialogFormAssetEdit = false),
          ],
        },
      }),
      _vm._v(" "),
      _c("DialogFormActivityAdd", {
        attrs: {
          showDialog: _vm.showDialogFormActivityAdd,
          selectedAssets: [_vm.assetDetail],
          clientList: _vm.clientList,
          activityTypeList: _vm.activityTypeList,
          userList: _vm.userList,
          locationList: _vm.locationList,
          modelList: _vm.modelList,
          assetStatusList: _vm.assetStatusList,
          isLoading: _vm.isLoading,
        },
        on: {
          onCancelClicked: function ($event) {
            _vm.showDialogFormActivityAdd = false
          },
          onSubmitClicked: (val) => [_vm.onDialogFormActivityAddSubmit(val)],
        },
      }),
      _vm._v(" "),
      _c("DialogFormAssetPropertyAdd", {
        attrs: {
          showDialog: _vm.showDialogFormAssetPropertyAdd,
          propertyKeyList: _vm.propertyKeyList,
          assetDetail: _vm.assetDetail,
          isLoading: _vm.isLoading,
        },
        on: {
          onCancelClicked: function ($event) {
            _vm.showDialogFormAssetPropertyAdd = false
          },
          onSubmitClicked: (val) => [
            _vm.onDialogFormAssetPropertyAddSubmit(val),
            (_vm.showDialogFormAssetPropertyAdd = false),
          ],
        },
      }),
      _vm._v(" "),
      _c("DialogFormAssetPropertyEdit", {
        attrs: {
          showDialog: _vm.showDialogFormAssetPropertyEdit,
          propertyKeyList: _vm.propertyKeyList,
          propertyToEdit: _vm.propertyToEdit,
          isLoading: _vm.isLoading,
        },
        on: {
          onCancelClicked: function ($event) {
            _vm.showDialogFormAssetPropertyEdit = false
          },
          onSubmitClicked: (val) => [
            _vm.onDialogFormAssetPropertyEditSubmit(val),
            (_vm.showDialogFormAssetPropertyEdit = false),
          ],
        },
      }),
      _vm._v(" "),
      _c("DialogFormConfirmation", {
        attrs: {
          showDialog: _vm.confirmationDialogShow,
          title: _vm.confirmationDialogTitle,
          message: _vm.confirmationDialogMessage,
          submitButtonText: _vm.confirmationDialogSubmitButtonText,
          submitButtonIcon: _vm.confirmationDialogSubmitButtonIcon,
          submitButtonColor: _vm.confirmationDialogSubmitButtonColor,
          cancelButtonText: _vm.confirmationDialogCancelButtonText,
          showCancelButton: _vm.confirmationDialogShowCancelButton,
          isLoading: _vm.isLoading,
        },
        on: {
          onSubmitClicked: _vm.onConfirmationDialogSubmitClicked,
          onCancelClicked: _vm.onConfirmationDialogCancelClicked,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }